<template>
  <div>
    <PageAllow controller="OrderMaterialAnalyze" action="monthAnalyzeView" />
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
      <v-sheet class="overflow-y-scroll fill-content-height">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetime
                type="month"
                v-model="datetimeRage"
                :label="$t('MonthlyStatisticss.orderCreatedTime')"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn
                v-if="
                  options.type == 1 &&
                  $permission.permissionAllow(
                    'OrderMaterialAnalyze',
                    'monthOrderDetailExport'
                  )
                "
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="monthOrderDetailExportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("Export.excel", ["MonthlyStatisticss.ObjectName"]) }}
              </v-btn>
              <v-btn
                v-if="
                  options.type == 2 &&
                  $permission.permissionAllow(
                    'OrderMaterialAnalyze',
                    'monthReturnOrderDetailExport'
                  )
                "
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="monthReturnOrderDetailExportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-excel</v-icon>
                {{ $t("Export.excel", ["MonthlyStatisticss.ObjectName"]) }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>

        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherShop v-model="shopSelected" />
                </v-col>
                <!-- 分组 -->
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="
                    settings && settings.report_hide_search_district_tree == 2
                  "
                >
                  <SearcherDistrictsWithDescendants
                    v-model="DistrictsSelected"
                    :label="
                      $t('shopDailyReports.shopDistricts', [$consts.shopName()])
                    "
                  />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <div
                    class="caption grey--text input-chip-group-label mb-n4"
                    :class="
                      $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                    "
                  >
                    {{ $t("MonthlyStatisticss.types.ObjectName") }}
                  </div>
                  <v-radio-group row v-model="options.type" dense class="mb-n4">
                    <v-radio
                      :label="$t('MonthlyStatisticss.types.monthlyOrder')"
                      :key="1"
                      :value="1"
                      class="me-1"
                    />
                    <v-radio
                      :label="$t('MonthlyStatisticss.types.monthlyReturnOrder')"
                      :key="2"
                      :value="2"
                      class="me-1"
                    />
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="6" md="5">
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('MonthlyStatisticss.status.title')"
                    :items="
                      options.type == 1
                        ? $consts.monthlyStatisticss.order_status
                        : $consts.monthlyStatisticss.return_order_status
                    "
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.cancel_flgs"
                    :label="$t('CancelFlgs.title')"
                    :items="$consts.cancelFlgs"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="orderDetails"
            :options.sync="options"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            :loading="loading"
            multi-sort
            class="elevation-2 px-4 pt-1"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:body.prepend>
              <tr class="d-none d-sm-table-row">
                <td>
                  <v-btn
                    v-if="settings && settings.report_hide_search_district_tree == 1"
                    small
                    outlined
                    color="info"
                    class="px-2 me-2"
                    :disabled="!districtID"
                    @click.stop="$emit('to-parent-district')"
                  >
                    <v-icon x-small class="pe-1">fa-reply</v-icon>
                    {{ $t("District.return") }}
                  </v-btn>
                  <span>{{ $t("TableSum") }}</span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>
                    {{ $t("Global.money") }}
                    {{ totalMoney | formatMoney }}
                  </span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>
                    {{ totalOrderNum | formatTwoDot }}
                  </span>
                </td>
                <td :align="$vuetify.rtl ? 'left' : 'right'">
                  <span>
                    {{ $t("Global.money") }}
                    {{ totalAverageMoney | formatMoney }}
                  </span>
                </td>
              </tr>
              <tr class="d-table-row d-sm-none">
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("TableSum") }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("MonthlyStatisticss.DetailFields.total_money") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}
                    {{ totalMoney | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("MonthlyStatisticss.DetailFields.total_order_num") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}
                    {{ totalOrderNum | formatMoney }}
                  </div>
                </td>
                <td class="v-data-table__mobile-row">
                  <div class="v-data-table__mobile-row__header">
                    {{ $t("MonthlyStatisticss.DetailFields.average_price") }}
                  </div>
                  <div class="v-data-table__mobile-row__cell">
                    {{ $t("Global.money") }}
                    {{ totalAverageMoney | formatMoney }}
                  </div>
                </td>
              </tr>
            </template>
            <template v-slot:item.created="{ item }">
              {{ item.created | formatDate }}
            </template>
            <template v-slot:item.total="{ item }">
              {{ $t("Global.money") }}{{ item.total | formatMoney }}
            </template>
            <template v-slot:item.num="{ item }">
              {{ item.num | formatTwoDot }}
            </template>
            <template v-slot:item.average_price="{ item }">
              {{ $t("Global.money") }}{{ item.average_price | formatMoney }}
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import SearcherShop from "@/components/plugins/SearcherShop";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import MonthlyStatisticss from "@/api/monthly_statisticss";
import Shops from "@/api/shops";
import SearcherDistrictsWithDescendants from "@/components/plugins/SearcherDistrictsWithDescendants";

const defaultOptions = {
  create_month: new Date().toISOString().substr(0, 7),
  shop_id: 0,
  status: [1, 2, 3],
  cancel_flgs: [0],
  type: 1,
  district_ids: [],
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetime,
    SearcherShop,
    SearcherStatus,
    SearcherDistrictsWithDescendants,
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.monthlyStatisticss"),
          disabled: false,
          href: "/monthly-statisticss",
        },
        {
          text: i18n.t("Nav.monthlyStatisticsDetails"),
          disabled: true,
        },
      ];
    },

    headers() {
      return [
        {
          text: i18n.t("MonthlyStatisticss.DetailFields.created_date"),
          align: "start",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("MonthlyStatisticss.DetailFields.total_money"),
          align: "end",
          sortable: false,
          value: "total",
        },
        {
          text: i18n.t("MonthlyStatisticss.DetailFields.total_order_num"),
          align: "end",
          sortable: false,
          value: "num",
        },
        {
          text: i18n.t("MonthlyStatisticss.DetailFields.average_price"),
          align: "end",
          sortable: false,
          value: "average_price",
        },
      ];
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "districtID"]),
  },

  data: () => ({
    datetimeRage: new Date().toISOString().substr(0, 7),
    options: JSON.parse(JSON.stringify(defaultOptions)),
    shopSelected: null,
    orderDetails: [],
    paging: {},
    totalMoney: 0,
    totalOrderNum: 0,
    totalAverageMoney: 0,
    shopId: "",
    DistrictsSelected: [],
  }),

  mounted() {
    this.$store.commit(
      "searchDistrict",
      this.settings && this.settings.report_hide_search_district_tree == 1
        ? true
        : false
    );

    this.getShopFromAPI();
    this.$commonUtils
      .loadOptions("monthly-statisticss-details", [
        "shopSelected",
        "DistrictsSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "shopSelected":
                this.shopSelected = selected.value;
                break;
              case "DistrictsSelected":
                this.DistrictsSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );

    //同步一览页面的搜索条件
    this.$commonUtils.loadOptions("monthly-statisticss").then(
      function (data) {
        if (data.options) {
          this.datetimeRage = data.options.create_month;
          this.options.create_month = data.options.create_month;
          this.options.status = data.options.status;
          this.options.cancel_flgs = data.options.cancel_flgs;
          this.options.type = data.options.type;
        } else this.resetSearch();
      }.bind(this)
    );
  },

  methods: {
    getShopFromAPI() {
      Shops.fetchOne(this.$route.params.shop_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shopSelected = response.data.shop;
          }
        }.bind(this)
      );
    },
    onSearch() {
      // 搜索
      this.getStatistcalDetailsFromAPI();
    },
    resetSearch() {
      this.shopSelected = null;
      this.DistrictsSelected = [];
      this.datetimeRage = new Date().toISOString().substr(0, 7);
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getStatistcalDetailsFromAPI() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      MonthlyStatisticss.fetchDetails(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.orderDetails = response.data.orders;
            this.totalMoney = response.data.total;
            this.totalOrderNum = response.data.num;
            this.totalAverageMoney = response.data.average_price;
          }
        }.bind(this)
      );
    },
    monthOrderDetailExportExcel() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      MonthlyStatisticss.orderDetailExports(options);
    },
    monthReturnOrderDetailExportExcel() {
      var options = JSON.parse(JSON.stringify(this.options));
      if (
        this.settings &&
        this.settings.report_hide_search_district_tree == 1
      ) {
        options = Object.assign(options, {
          district_id: this.districtID,
        });
      }
      MonthlyStatisticss.ReturnOrderDetailExports(options);
    },
  },

  watch: {
    districtID: {
      handler() {
        this.getStatistcalDetailsFromAPI();
      },
    },
    options: {
      deep: true,
      handler() {
        this.getStatistcalDetailsFromAPI();
        sessionStorage.setItem(
          "monthly-statisticss-details-options",
          JSON.stringify(this.options)
        );
      },
    },
    datetimeRage: {
      handler() {
        if (this.datetimeRage == "") {
          this.datetimeRage = new Date().toISOString().substr(0, 7);
        } else {
          this.options.create_month = this.datetimeRage;
        }
      },
    },
    shopSelected: {
      handler() {
        this.options.shop_id = this.shopSelected ? this.shopSelected.id : 0;
        sessionStorage.setItem(
          "monthly-statisticss-details-shopSelected",
          JSON.stringify(this.shopSelected)
        );
      },
    },
    DistrictsSelected: {
      handler() {
        if (this.settings &&
          this.settings.report_hide_search_district_tree == 2)
        { 
          this.options.district_ids = this.DistrictsSelected
            ? this.DistrictsSelected.map((e) => {
              return e.id;
            })
            : [];
          sessionStorage.setItem(
            "monthly-statisticss-details-DistrictsSelected",
            JSON.stringify(this.DistrictsSelected)
          );
        }
      },
    },
     settings: {
      handler() {
        this.$store.commit(
          "searchDistrict",
          this.settings && this.settings.report_hide_search_district_tree == 1
            ? true
            : false
        );
      },
    },
  },
};
</script>